import { render, staticRenderFns } from "./User.vue?vue&type=template&id=f3856c3c&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src736765657/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3856c3c')) {
      api.createRecord('f3856c3c', component.options)
    } else {
      api.reload('f3856c3c', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=f3856c3c&", function () {
      api.rerender('f3856c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/User.vue"
export default component.exports